<template>
  <ons-toolbar class="toolbar-player toolbar-customize toolbar toolbar--transparent" modifier="transparent" cover-content="" noshadow="" v-show="couldShow && !!player.mediumUrl">
    <div class="progress-bar"
      v-bind:style="{ width: player.currentPerc+'%' }"
    ></div>
    <div class="img-wp">
      <a href=""
        @click.prevent=""
        v-if="!player.mediumUrl"
      >
        <img class="thumb_img round-sm" :src="constants.phImg300x300" width="300" height="300" alt="" v-if="!imageUrl" />
        <img-with-placeholder class="thumb_img round-sm" :src="constants.phImg300x300" :data-src="sizeImg(imageUrl, 300, 300)" width="300" height="300" alt="" v-else />
      </a>
      <a href=""
        @click.prevent="navigatorPush('Episode', { id: player.episodeId, title: player.title, skipAutoPlay: true }, { animation: 'lift'})"
        v-else
      ><img-with-placeholder class="thumb_img round-sm" :src="constants.phImg300x300" :data-src="sizeImg(player.imageUrl, 300, 300)" width="300" height="300" alt="" /></a>
    </div>
    <div class="controls">
      <button class="fast-backward flat-button"
        :disabled="!player.mediumUrl"
        v-bind:class="{ disabled: !player.mediumUrl }"
        @click="rewind()"
      >
        <icon-fast-backward />
        <span class="dur">{{ currentUser.rewind_duration }}</span>
      </button>
      <button class="play flat-button js-button-toggle"
          v-bind:class="{ switched: player.playing, buffering: player.buffering }"
          @click="playOrPauseWrapper()"
        >
        <icon-play />
      </button>
      <button class="fast-forward flat-button"
        :disabled="!player.mediumUrl"
        v-bind:class="{ disabled: !player.mediumUrl }"
        @click="skip()"
      >
        <icon-fast-forward />
        <span class="dur">{{ currentUser.skip_duration }}</span>
      </button>
    </div>
    <button class="close-button flat-button"
      @click="close()"
    ><icon-close /></button>
  </ons-toolbar>
</template>

<script>
import PlayerHelper from '@/mixins/PlayerHelper';

export default {
  props: ['imageUrl', 'onPlayOrPause', 'onClose', 'couldShow'],
  props: {
    imageUrl: Object,
    onPlayOrPause: Function,
    onClose: Function,
    couldShow: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [PlayerHelper],

  computed: {
    player() {
      return this.$store.state.player;
    },
  },

  methods: {
    close() {
      this.playerClose();
      if (this.onClose) { this.onClose(); }
    },
    playOrPauseWrapper() {
      if (this.onPlayOrPause) {
        this.onPlayOrPause(true);
        return;
      }
      this.playOrPause(null, null, true);
    },
  },
};
</script>
